import React from 'react';
import 'highcharts/modules/sunburst';
import GenericChart from '../GenericChart';

const SunBurstWrapper = ({ topics_hierarchy_data, seriesLevel, chartDefaultConfig }) => {

  const series = [
    {
      type: 'sunburst',
      data: topics_hierarchy_data,
      allowDrillToNode: true,
      cursor: 'pointer',
      borderWidth: 1,
      borderColor: '#1e293b',
      colorByPoint: false,
      levels: seriesLevel
    }
  ]


  return (

    <GenericChart
      defaultConfig={chartDefaultConfig}
      series={series}
      tooltipValueKeysConfig={{
        isheaderVisible: true,
        headerLabelKey: "name",
        bodyLabelKey: "",
        bodyLabelValue: "Mentions",
        bodyValueKey: "value"
      }}

    />

  );
};

export default SunBurstWrapper;